
import React from 'react'
import styled from 'styled-components'
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { education } from '../../data/constants';
import EducationCard from '../Cards/EducationCard';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    padding: 0px 0px 60px 0px;
    @media (max-width: 960px) {
        padding: 0px;
    }
`;

const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1350px;
    padding: 40px 0px 0px 0px;
    gap: 12px;
    @media (max-width: 960px) {
        flex-direction: column;
    }
`;

const Title = styled.div`
  font-size: 48px;
  text-align: center;
  font-weight: 800;
  margin-top: 20px;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #FFFFFF 0%, #FFFFFF 60%, #854CE6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  position: relative;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 8px 16px;
  border-radius: 12px;
  
  &:hover {
    background: linear-gradient(135deg, #FFFFFF 0%, #FFFFFF 40%, #FF6B6B 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    transform: translateY(-2px);
    
    &::after {
      background: linear-gradient(90deg, #FF6B6B, #ff8a8a);
      width: 80px;
    }
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #854CE6, #FF6B6B);
    border-radius: 2px;
    transition: all 0.3s ease;
  }
  
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 36px;
  }
`;

const Desc = styled.div`
    font-size: 20px;
    text-align: center;
    max-width: 700px;
    color: ${({ theme }) => theme.text_primary};
    opacity: 0.8;
    line-height: 1.6;
    margin-bottom: 8px;
    font-weight: 400;
    
    @media (max-width: 768px) {
        font-size: 18px;
        max-width: 500px;
        margin-top: 12px;
    }
`;

const TimelineSection = styled.div`
    width: 100%;
    max-width: 1000px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    
     .MuiTimelineDot-root {
         background: linear-gradient(135deg, #FF6B6B, #ff8a8a) !important;
         border: 3px solid rgba(255, 107, 107, 0.3) !important;
         width: 16px !important;
         height: 16px !important;
         box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4) !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
     }
     
     .MuiTimelineDot-root:hover {
        transform: scale(1.2) !important;
         box-shadow: 0 6px 20px rgba(255, 107, 107, 0.6) !important;
     }
     
     .MuiTimelineConnector-root {
         background: linear-gradient(180deg, #FF6B6B, #ff8a8a) !important;
        width: 3px !important;
        opacity: 0.8 !important;
     }
    
    .MuiTimeline-root {
        padding: 0 !important;
    }
    
    @media (max-width: 660px) {
        align-items: end;
    }
`;



const index = () => {
    return (
        <Container id="education">
            <Wrapper>
                <Title>Education</Title>
                <Desc>
                    My education has been a journey of self-discovery and growth. My educational details are as follows.
                </Desc>
                <TimelineSection>
                    <Timeline>
                        {education.map((education,index) => (
                            <TimelineItem >
                                <TimelineContent sx={{ py: '12px', px: 2 }}>
                                    <EducationCard education={education}/>
                                </TimelineContent>
                                <TimelineSeparator>
                                    <TimelineDot />
                                    {index !== education.length - 1 && <TimelineConnector />}
                                </TimelineSeparator>
                            </TimelineItem>
                        ))}
                    </Timeline>

                </TimelineSection>
            </Wrapper>
        </Container>
    )
}

export default index